import React from "react"
import Layout from "../components/layout"
import "../css/faq.css"
import SEO from "../components/seo"


const faqData = [
  {
    name: "About Project Ares",
    image: "https://staging.circadence.com/wp-content/uploads/2020/06/TrainerView_Performance.jpg",
    questions: [
      {
        q: "Who can learn cyber security with Project Ares?"
      }, {
        q: "Do I have to have prerequisite cyber knowledge to use Project Ares?"
      }, {
        q: "How does Project Ares align or update with the latest threat attacks to keep skills fresh?"
      }, {
        q: "What is the value of gamification as a learning strategy for skill building? "
      }
    ],
    answers: [
      {
        a: "Project Ares is the perfect tool for any individual, team or organization looking to expand their cyber skillset and readiness posture. Project Ares allows cyber teams from enterprise, government, and higher education institutions to augment the cyber workforce by providing hands-on, gamified cyber range learning exercises that emulate networks at risk. Realistic scenarios engage teams and individuals in immersive virtual environments using real-world tools, network activity and a large library of authentic threat scenarios."
      }, {
        a: "Project Ares cyber learning games and media library provide resources for learning cyber security basic concepts and can help a cyber novice get started.   Foundational skills are taught though hands-on exercises in the virtual range that can be repeated with and without hints until mastered.<br/><br/> Users advance skills and develop critical thinking abilities to defeat threats built into more complex training scenarios. More experienced cyber professionals will be challenged in individual and team-based play that includes network recon and confronting threats like botnets, phishing and exfiltration, ransomware, and more. "
      }, {
        a: "Project Ares instructional designers and mission architects are constantly developing new cyber learning scenarios that reflect today’s cyber breach incidents."
      }, {
        a: "Unlike compliance-driven teaching methods, gamified teaching engages students individually and in teams through modern learning strategies. It works by deploying connected, interactive, social settings that allow users to excel in competitive, strategic situations. It allows users to apply what they know to simulated environments, creating a natural “flow” that keeps them engaged and focused. <a href='https://marketing.circadence.com/acton/media/36273/get-gamified--a-cyber-learning-webinar' target='_blank'> Watch our on-demand webinar</a> “why learning happens better with games” or <a href='/blog/the-benefits-of-active-gamified-learning-in-cyber-training/#:~:text=Organizations%20that%20offer%20gamified%20exercises,rewarded%20for%20good%20behavior' target='_blank'>read our blog</a> on “the benefits of gamification” for more information."
      }
    ]
  }, {
    name: "Features and Functions ",
    image: "https://staging.circadence.com/wp-content/uploads/2020/03/leaderboard.png",
    questions: [
      {
        q: "Is the scoring applied when a specific approach is used?  In other words, can I find the right answer but in a different way and still get credit?"
      }, {
        q: "Are all the tools learned in Project Ares open source? Any vendor specific?"
      }, {
        q: "Is there an AI component in Project Ares?  "
      }, {
        q: "Does Project Ares have any SIEM simulators?   "
      }
    ],
    answers: [
      {
        a: "There are two methods for grading: First, through ‘umpire checks’ where the system automatically looks for a specific answer or outcome. Second, grading is based on the path or steps the user takes to solve a problem. If a user completes something correctly and does not receive credit, the user can <a href='/contact/support'>reach out to Circadence.</a> As new approaches are constantly developed, we are always trying to increase the capability of umpire checks to account for varied routes to problem-solving."
      }, {
        a: "The majority of tools within the Project Ares platform are open source. We do this to keep the cost of the platform lower and to help ensure that the learning focus is on building skills vs. working with a specific tool functionality. Currently, users will find Splunk, Linux,  and some Windows-based tools that they can train with."
      }, {
        a: "AI is used to create the adversary in Project Ares scenarios, acting as a force multiplier for offensive capabilities. The Project Ares in-game advisor “Athena,” communicates with users in a chat bot format to bring answers to questions, provide hints and guide users through activities. Athena generates responses from its learning corpus to aggregate knowledge about how a user progresses through learning scenarios and Athena recommends the most efficient path to solving a problem. To learn more about how AI and gamification are deployed in Project Ares, <a href='https://marketing.circadence.com/acton/media/36273/upskill-cyber-teams-with-artificial-intelligence-and-gamified-learning-whitepaper' target='_blank'>download this white paper</a> and <a href='https://marketing.circadence.com/acton/media/36273/webinar-how-gamification-ai-will-revolutionize-cyber-skill-acquisition' target='_blank'>watch this webinar</a>. "
      }, {
        a: "Project Ares does not need to simulate a SIEM because the platform uses high-fidelity environments with an adversary framework which can allow for full SIEMs where appropriate."
      }
    ]
  }, {
    name: "Buying Project Ares",
    image: "https://staging.circadence.com/wp-content/uploads/2019/11/circCorp_aboutUs_frame_02940-1.jpg",
    questions: [
      {
        q: "Can I see a demonstration of Project Ares before I purchase it? "
      }, {
        q: "How can I purchase Project Ares?  "
      }, {
        q: "How does the cost of Project Ares compare to off-site course trainings?  "
      }
    ],
    answers: [
      {
        a: "Yes, for those interested in individual subscriptions, <a href='https://marketing.circadence.com/acton/media/36273/webinar-project-ares-demo-2019-10' target='_blank'>this on-demand demonstration</a> gives insight into what the platform looks like and how it works. <a href='https://marketing.circadence.com/acton/media/36273/webinar-project-ares-demo-2019-10' target='_blank'>Watch an on-demand demonstration now.</a> <br/><br/> For those interested in purchasing  organizational subscriptions, a Circadence representative will deliver a 1:1 live demonstration. <a href='https://calendly.com/circadence-sales/discovery-call' target='_blank'>Request a demo here</a>."
      }, {
        a: "Projet Ares Academy is designed for  students/career changers and individual learners. <a href='/project-ares' target='__blank'>It can be purchased online.</a><br/><br/> Project Ares Enterprise is designed for organizations and institutions <a href='https://calendly.com/circadence-sales/discovery-call'>Schedule an information call.</a>.<br/><br/>The configuration details for the subscription plans are available <a href='/project-ares' target='__blank'>here.</a>"
      }, {
        a: "An average off-site cyber security course training can cost upwards of $5-8,000 for a one-time experience. This does not include cost to travel to the training, hotel, and any other “add-ons” desired. Project Ares Annual Enterprise subscription is comparable to a single trip for standard off-site training and it offers 24/7 access to train and learn regardless of where you are geographically.  "
      }
    ]
  }, {
    name: "Getting Started in Project Ares  ",
    image: "https://staging.circadence.com/wp-content/uploads/2019/07/coaching-coders-coding-7374.jpg",
    questions: [
      {
        q: "How do I get started in Project Ares? "
      }
    ],
    answers: [
      {
        a: "Customers who purchase an individual Academy subscription from our online store will receive an email invitation to access our single sign-on portal, CyberBridge, after our Customer Support team has verified your account. Customers are provided a ‘Getting Started Guide’ to help them access the platform and use its features/functions. <br/><br/>If you’ve purchased a Project Ares organizational subscription, our Customer Success team works directly with you to tailor the best approach for onboarding your members or your company, organization, or school. Additionally, your account administrator(s) will be provided with the tools and privileges to manage individuals within the account. Customers are also provided a ‘Getting Started Guide’ to help them access the platform and use its features/functions. "
      }
    ]
  }, {
    name: "Using Project Ares",
    image: "https://staging.circadence.com/wp-content/uploads/2020/05/https___specials-images.forbesimg.com_dam_imageserve_961040530_960x0-1.jpg",
    questions: [
      {
        q: "How do I access Project Ares?  "
      }, {
        q: "Can students use Project Ares?  "
      }, {
        q: "What can I learn in Project Ares?"
      }, {
        q: "Can a user with no experience use the Project Ares platform? "
      }, {
        q: "Can I receive any documents or certification after training?  "
      }, {
        q: "Can you earn CPEs/CEUs credits using Project Ares?  "
      }, {
        q: "Are the training activities aligned to any certifications or can the content prepare users for a cert?  "
      }, {
        q: "How can I download Project Ares?   "
      }, {
        q: "Is internet access available from the platform?  "
      }, {
        q: "Can I use Project Ares on my phone or tablet? "
      }, {
        q: "Can I customize the content in the platform? "
      }
    ],
    answers: [
      {
        a: "Project Ares is accessed via the browser on a Circadence portal called <a href='/cyberbridge' target='_blank'>CyberBridge</a>. <a href='/cyberbridge' target='_blank'>CyberBridge</a> is the single sign-on portal for Circadence clients to access learning solutions and reporting tools. "
      }, {
        a: "Yes! Project Ares has been used for many U.S. cyber competitions and events that students partake in. From the <a href='/blog/socal-cyber-cup-challenge-finals-wrap-6-month-long-cyber-program/' target='blank'>SoCal Cyber Cup</a> to the  <a href='https://www.youtube.com/watch?v=detC6rXkaMo' target='blank'>Wicked6 Cyber Games event in Las Vegas</a> to being incorporated into  <a href='https://marketing.circadence.com/acton/media/36273/immersive-cyber-curriculum-with-project-ares-use-case-university-of-colorado-boulder' target='blank'>learning curriculum at a U.S.-based public research institution</a> and trade school  <a href='/blog/guest-blog-reimagining-cyber-learning-for-students-featuring-divergence-academy/' target='blank'>Divergence Academy</a>,  <a href='https://staging.circadence.com/wp-content/uploads/2020/04/Calhan-HS-success-story-Final.pdf' target='blank'>Calhan High School</a>, and  <a href='https://staging.circadence.com/wp-content/uploads/2020/03/Miliam-Elementary-Case-Study.pdf' target='blank'>Milam Elementary</a>, to name a few…  "
      }, {
        a: "Users can learn foundational and specialized concepts and topics related to cyber security.  “Basics” like ports and protocols, regular expressions, and phases of the Cyber Kill Chain are available the platform’s foundational scenario activities.<br/><br/>Tools, Tactics and Procedures are learned in specialized scenarios for skill development, e.g. scripting, forensics, etc. Other advanced scenarios include individual or team-based activities that deliver gamified backstories of real-life cyber-attacks to learn network recon, disabling botnets, phishing and exfiltration, ransomware, and more. <br/><br/>The library of Project Ares learning exercises support specialty work roles and competencies aligned to the <a href='https://www.nist.gov/itl/applied-cybersecurity/nice/nice-cybersecurity-workforce-framework-resource-center' target='_blank'>NIST/NICE Cyber Security Workforce Framework</a> for industry-leading cyber learning.  Additionally, some of the Project Ares exercises are organized into assessment paths across 5 work roles:  Cyber Defense Analyst, Cyber Defense Infrastructure Specialist, Threat/Warning Analyst, System Security Analyst, and Team Lead.   When a player completes one of these Project Ares work role assessment paths, they achieve an in-game certificate.   "
      }, {
        a: "Currently, Project Ares is built for users with a background or a disposition to InfoSec and cyber security. We suggest novices use the cyber learning games and foundational scenarios first before engaging in the specialized scenario activities. "
      }, {
        a: "Within the Project Ares environment, users can earn a Circadence Certificate of Achievement when specific work role assessment paths are completed.  The Project Ares learning exercises are aligned to the NIST/NICE Framework Work Roles and the in-game certificates informally document skill mastery.<br/><br/>Project Ares is a terrific hands-on platform to practice for formal industry standard certification programs like those governed by CompTIA, GSEC, or others. Project Ares is not tied directly to industry certification testing.  "
      }, {
        a: "Time  spent learning and honing skills in Project Ares can be documented for Continuing Education (CU) or Continuing Professional Education (CPE) credits To request verification of completed activities within Project Ares, please <a href='/ares-accomplishments-verification' target='_blank'>visit this web page to request documentation for CEU/CPE credits</a>.  "
      }, {
        a: "Training with Project Ares can help users prepare for formal industry certifications, such as CISSP, Security +, CEH, etc. Project Ares gives users hands-on experience to increase the probability of successfully passing these tests.  However, Project Ares is not tied directly to industry certification testing. "
      }, {
        a: "Project Ares is a browser-based learning tool. Upon purchase of a subscription, you will be on-boarded by Circadence Customer Support manager and then able to set up your own log-in credentials to access the training content.   "
      }, {
        a: "As a virtual cyber range, the Project Ares learning scenarios do not need to be online as they are sandbox environments that create a safe space for learning without impacting actual networks that are online. "
      }, {
        a: "Project Ares is designed to be used on a laptop or PC. Many of the sections require the user to open multiple screens which would be very difficult on a phone. <br/><br/>System requirements for Project Ares and the CyberBridge portal are <a href='https://staging.circadence.com/wp-content/uploads/2020/08/Circadence-Commercial-Products-System-Requirements_June2020.pdf' target='_blank'>detailed here</a>.  "
      }, {
        a: "Through the Trainer View interface, an instructor or manager can make adjustments that affect how their users experience the training scenarios.<ul><li> Hints can be turned on or off.</li><li>Help through the Athena chatbot can be turned on or off.</li><li>The AI adversary can be turned on or off </li></ul>However, trainers and players cannot add additional learning content to the platform.<br/><br/>Circadence is developing tools and training that will make Project Ares content development feasible, faster and more accessible for organizations.  More details coming soon.  <br/><br/>In the meantime, Circadence offers a customization service package to create learning scenarios for customers at an additional fee. "
      }
    ]
  }
];

// returns object with text to be parsed into JSX
function createMarkup(string) {
  return {__html: string}
}

class FAQ extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      activeSection: faqData[0]
    }
  }

  componentDidMount = () => {
    let activeIndex = faqData.indexOf(this.state.activeSection)
    document.getElementById(`tbox-${activeIndex}`).classList.add("active-section")
  }

  handleSectionChange = (index) => {
    // Janky, but it works
    let others = document.getElementsByClassName('active-section')
    for (let i = 0; i < others.length; i++) {
      others[i].classList.remove("active-section")
    }
    document.getElementById(`tbox-${index}`).classList.add("active-section")
    this.setState({
      activeSection: faqData[index]
    })
  }

  toggleDropdown = (id) => {
    console.log(id);
    let content = document.getElementById(`ct-${id}`)

    console.log(content.style);
    if (content.style.maxHeight == "0px" || !content.style.maxHeight) {
      document.getElementById(`icon-${id}`).innerHTML = "–"
      content.style.maxHeight = content.scrollHeight + "px"
    } else {
      document.getElementById(`icon-${id}`).innerHTML = "+"
      content.style.maxHeight = "0px"
    }
  }

  render() {
    return (
      <Layout>
        <SEO title="Frequently Asked Questions"/>
        <div id="header-content-wrapper">
          <h2 className="main-title" style={{textAlign: "center"}}>Frequently Asked Questions</h2>
          <div id="nav-container">
            {faqData.map((topic) => {
              let idx = faqData.indexOf(topic)
              return (
                <div className="topic-container">
                  <div className="topic-box" id={`tbox-${idx}`} onClick={() => this.handleSectionChange(idx)}>
                    <button className="topic-title">{topic.name}</button>
                    <div className="topic-image" style={{backgroundImage: `url(${topic.image})`}}></div>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
        <div id="main-content" style={{padding: 50}}>
          <h2 style={{marginBottom: 30, flexBasis: "100%"}}>{this.state.activeSection.name}</h2>
            {this.state.activeSection.questions.map((q) => {
              let idx = this.state.activeSection.questions.indexOf(q)
              let answer = this.state.activeSection.answers[idx].a
              return (
                <div>
                  <button className="collapse" onClick={() => this.toggleDropdown(idx)}>
                    <h4 style={{margin: "0 15px 0 5px"}} id={`icon-${idx}`}>+ </h4>
                    <h4>{q.q}</h4>
                  </button>
                  <div className="drawer-contents" id={`ct-${idx}`}>
                    <p dangerouslySetInnerHTML={createMarkup(answer)}></p>
                  </div>
                </div>
              )
            })}
        </div>
      </Layout>
    )
  }

}

export default FAQ;
